var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48847 11.4467C7.18499 11.2768 6.81505 11.2768 6.51158 11.4467L4.18973 12.7463C3.44513 13.1631 2.55418 12.5159 2.72045 11.6789L3.23895 9.06895C3.30672 8.72783 3.19239 8.376 2.93704 8.13988L0.983162 6.33317C0.35663 5.75382 0.696908 4.70641 1.5443 4.60591L4.18688 4.2925C4.53221 4.25155 4.83147 4.03412 4.97714 3.71835L6.09199 1.30165C6.44942 0.526834 7.55063 0.526835 7.90806 1.30165L9.0229 3.71835C9.16857 4.03412 9.46783 4.25155 9.81317 4.2925L12.4557 4.60591C13.3031 4.70641 13.6434 5.75382 13.0169 6.33317L11.063 8.13988C10.8077 8.376 10.6933 8.72783 10.7611 9.06895L11.2796 11.6789C11.4459 12.5159 10.5549 13.1631 9.81032 12.7463L7.48847 11.4467Z",
    fill: "#1D474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusive);
export default __webpack_public_path__ + "static/media/exclusive.d21327c5004d6951bd51e87f5e542df7.svg";
export { ForwardRef as ReactComponent };